import Desktop from "./desktop";
import Mobile from "./mobile";

const index = (props) => {

	const prop = props;

	if (prop.isMobile) {

		return (
			<Mobile {...prop} />
		);

	}

	return (
		<Desktop {...prop} />
	);

};

export default index;
